
import { Container, Row, Col, Nav } from "react-bootstrap";
import 'animate.css';
import TrackVisibility from 'react-on-screen';
import webClassImg from '../assets/img/stblogcover.jpg';
import atp1Img from '../assets/img/atp1.jpg';
import atp2Img from '../assets/img/atp2.jpg';
import atp3Img from '../assets/img/atp3.jpg';
import atp4Img from '../assets/img/atp4.jpg';
import atp5Img from '../assets/img/atp5.jpg';
import atp6Img from '../assets/img/atp6.jpg';
import atp16Img from '../assets/img/atp16.jpg';
import atp8Img from '../assets/img/atp8.jpg';
import atp9Img from '../assets/img/atp9.jpg';

import atp10Img from '../assets/img/atp10.jpg';
import atp11Img from '../assets/img/atp11.jpg';
import atp12Img from '../assets/img/atp12.jpg';
import atp13Img from '../assets/img/atp13.jpg';
import atp14Img from '../assets/img/atp14.jpg';
import atp18Img from '../assets/img/atp18.jpg';
import atp20Img from '../assets/img/atp20.jpg';
import atp21Img from '../assets/img/atp21.jpg';
import atp15Img from '../assets/img/atp15.jpg';
import atp22Img from '../assets/img/atp22.jpg';
import atp23Img from '../assets/img/atp23.jpg';
import atp24Img from '../assets/img/atp24.jpg';
import atp24bImg from '../assets/img/atp24b.jpg';

import atp25Img from '../assets/img/atp25.jpg';
import atp26Img from '../assets/img/atp26.jpg';
import atp27Img from '../assets/img/atp27.jpg';


export const SketchwareTheoryGuide = () => {
 
  return (
    <section className="career" id="career">
      <Container>
        <Row className="aligh-items-center">
          <Col xs={12} md={6} xl={7}>
            <TrackVisibility>
              {({ isVisible }) =>
              <div className={isVisible ? "animate__animated animate__fadeIn" : ""}>
                <h3>Sketchware</h3>
                <h1><span className='quoteHeader'>Mobile App Development</span> Theoretical Guide.</h1>
                <h4>Totlesoft App Development Academy (TADA)</h4><br />

                <br />
                  <TrackVisibility>
                    {({ isVisible }) =>
                    <div className={isVisible ? "animate__animated animate__zoomIn" : ""}>
                    <Nav.Link href='https://selar.co/ztpm' rel="noreferrer" target='_blank'><img src={webClassImg} alt="example Img"/></Nav.Link>
                    </div>}
                  </TrackVisibility>
                  <br />
                  <br />

                <h5>Do you want to learn how to Develop Mobile App without coding and get paid when other people use it? IF YES, this course is for you.</h5><br />

                  <h3>Special Offer Currently Open. <span className="chris">90% Off - Ending Soon!</span> Act now!</h3><br />

                  <h5>In this course, you will be taught the step by step guide to developing different types of App without coding or technical skills.</h5><br />
                  
                  <p>Learning a skill has now become way easier with this one and only Online course that provides you with the needed environment, materials, and mentorship you need to not just learn one of the most profitable skills, but also ensures you master and make money from it.</p>
                  <p>Before you miss out on this once in a lifetime opportunity so many App Developers have enjoyed, hear me out.</p>
                  <p>Totlesoft App Development Academy (TADA) is the most resourceful App Development online course that helps you learn effectively in no time the theories, practicals and best practices in App Design and Development that can turn you into a professional in less than a week.</p><br />

                  <h5>Here is a student that bought this course on Thursday...</h5>
                  <br />
                  <TrackVisibility>
                    {({ isVisible }) =>
                    <div className={isVisible ? "animate__animated animate__zoomIn" : ""}>
                    <img src={atp1Img} alt="example Img"/>
                    </div>}
                  </TrackVisibility>
                  <br />
                  <br />

                  <h5>And was able to create an App on Saturday (An Ecommerce/Online Store App)</h5>
                  <br />
                  <TrackVisibility>
                    {({ isVisible }) =>
                    <div className={isVisible ? "animate__animated animate__zoomIn" : ""}>
                    <img src={atp2Img} alt="example Img"/>
                    </div>}
                  </TrackVisibility>
                  <br />
                  <br />

                  <h3 className="chris">Learn at your own pace</h3>
                  <p>So much effort was put into this course by our Software Experts in that you can be able to master everything in a day or two, or in a week, depending on your commitment to become an App Developer. There are comprehensive theories and practical videos to guide you all the way without any supervision and you will be able to achieve your aim.</p><br />

                  <h5>Here is another proof from a student sent to our App Dev Support WhatsApp Group. He bought this course and was able to build a PDF Converting App within a short period.</h5>
                  <br />
                  <TrackVisibility>
                    {({ isVisible }) =>
                    <div className={isVisible ? "animate__animated animate__zoomIn" : ""}>
                    <img src={atp3Img} alt="example Img"/>
                    </div>}
                  </TrackVisibility>
                  <br />
                  <br />
                  
                  <h3>What will I benefit from this training?</h3>
                  <p>If you learn and practice all you would be taught in this practical course, you would be able to do the following without stress or any wasting of time.</p>
                  <p>💡 Understand App Design Tools</p>
                  <p>💡 Create Frontend (User Interface -UI) for an App</p>
                  <p>💡 Creat Backend (Server Side/Database) for an App</p>
                  <p>💡 Link both the Frontend and Backend of an App and have a Fully Functioning App (As a Full Stack Developer)</p>
                  <p>💡 Know where to get Free App Content for your App Development</p>
                  <p>💡 Customize App Source Files</p>
                  <p>💡 Select an App Niche</p>
                  <p>💡 Convert any website to an App</p>
                  <p>💡 Publish an App to Play/Apple Store</p>
                  <p>💡 Monetize your finished App and get paid in Dollars</p>
                  <p>💡 and Many More...</p><br />

                  <Nav.Link href='https://selar.co/ztpm' rel="noreferrer" target='_blank'><h3 className="chris">PAY - REGISTER HERE</h3></Nav.Link><br />

                  <h5>Here is another proof from a student sent to our App Dev Support WhatsApp Group. He bought this course and can now convert a website to an App.</h5>
                  <br />
                  <TrackVisibility>
                    {({ isVisible }) =>
                    <div className={isVisible ? "animate__animated animate__zoomIn" : ""}>
                    <img src={atp4Img} alt="example Img"/>
                    </div>}
                  </TrackVisibility>
                  <br />
                  <br />

                  <h3 className="chris">LIFETIME SUPPORT AND MENTORSHIP</h3>
                  <h5>Unlike others who will sell a course and abandon you, Totlesoft App Development Academy has a very strong support team to guide and help you all the way. After Successful Purchase of this course, you will have access to a page where you can find the link to join the TOTLESOFT APP DEV. SUPPORT GROUP.</h5>
                  <br />
                  <TrackVisibility>
                    {({ isVisible }) =>
                    <div className={isVisible ? "animate__animated animate__zoomIn" : ""}>
                    <img src={atp5Img} alt="example Img"/>
                    </div>}
                  </TrackVisibility>
                  <br />
                  <br />

                  <h5>In the <span className="chris">SUPPORT GROUP</span>, you will be able to ask any question and get clearity on any unclare part during your training. Many student have attested to it that TOTLESOFT APP DEV. SUPPORT GROUP is very active and reliable. You're sure to get answers almost immediately. See what a student said bellow:</h5>
                  <br />
                  <TrackVisibility>
                    {({ isVisible }) =>
                    <div className={isVisible ? "animate__animated animate__zoomIn" : ""}>
                    <img src={atp6Img} alt="example Img"/>
                    </div>}
                  </TrackVisibility>
                  <br />
                  <br />

                  <h3 className="chris">Here is why you need to enroll in this course now:</h3>
                  <p>💡 You don't need any coding or technical skill</p>
                  <p>💡 You will be able to create any type of App in few hours of getting this course</p>
                  <p>💡 You will not be paying for any tools in creating App</p>
                  <p>💡 You don't need a Laptop, everything can be done with your Mobile Phone</p>
                  <p>💡 You will be able to monetize your App with google AdMob</p>
                  <p>💡 All App is 100% secured</p>
                  <p>💡 It is very cheap right now (Price may increase soon as more people enroll)</p><br />

                  <h5>Here this sweet testimony of a student from Ghana...</h5>
                  <br />
                  <TrackVisibility>
                    {({ isVisible }) =>
                    <div className={isVisible ? "animate__animated animate__zoomIn" : ""}>
                    <img src={atp16Img} alt="example Img"/>
                    </div>}
                  </TrackVisibility>
                  <br />
                  <br />

                  <Nav.Link href='https://selar.co/ztpm' rel="noreferrer" target='_blank'><h3 className="chris">PAY - REGISTER HERE</h3></Nav.Link><br />

                  <h3>FREQUENTLY ASK QUESTIONS</h3><br />
                  <h5 className="chris">Can I use my smartphone to create an App?</h5>
                  <p>YES, That's exactly what you will be learning in this App Development Course.</p><br />

                  <h5 className="chris">How long will the training last?</h5>
                  <p>You learn at your own pace. After payment, you will be granted access to the course and all the materials you needed. It could take you just few hours, a day or two, or a week, or a month, but most of our student where able to master App development through the simplicity and clearness of the syntax used in the packaging of this course within few hours after purchase. It's simply up to you.</p><br />

                  <h5 className="chris">When and where do I get the training after payment?</h5>
                  <p>This course is an already made training packed in a google drive file for you to study anytime. And you will be given access to it immediately you make payment.</p><br />

                  <h5 className="chris">Can a beginner like me that doesn't have any coding or tech knowledge be able to learn this course?</h5>
                  <p>YES, this training is targeted at people like you. Anybody that can read can get this course and create an App in few hours as it is not technical and you don't need any coding/tech skill.</p><br />

                  <h5 className="chris">Can I enroll tomorrow?</h5>
                  <p>YES, you can get this course whenever you want, but you might not meet it at the current price.</p><br />

                  <h5 className="chris">If I ran into any issue, will there be any help or support from you?</h5>
                  <p>YES, Totlesoft App Development Academy has a very strong support team that are ever ready to guide you all the way. You will have access to the group link after payment.</p><br />

                  <h1>Few <span className="chris">Live Apps</span> Created by Our Students Around The Globe</h1><br />

                  <h5>GAME APP</h5>
                  <br />
                  <TrackVisibility>
                    {({ isVisible }) =>
                    <div className={isVisible ? "animate__animated animate__zoomIn" : ""}>
                    <img src={atp8Img} alt="example Img"/>
                    </div>}
                  </TrackVisibility>
                  <br />
                  <br />

                  <h5>BROWSER APP</h5>
                  <br />
                  <TrackVisibility>
                    {({ isVisible }) =>
                    <div className={isVisible ? "animate__animated animate__zoomIn" : ""}>
                    <img src={atp9Img} alt="example Img"/>
                    </div>}
                  </TrackVisibility>
                  <br />
                  <br />

                  
                  <h5>ROMANCE GAME APP</h5>
                  <br />
                  <TrackVisibility>
                    {({ isVisible }) =>
                    <div className={isVisible ? "animate__animated animate__zoomIn" : ""}>
                    <img src={atp10Img} alt="example Img"/>
                    </div>}
                  </TrackVisibility>
                  <br />
                  <br />

                  <h5>FOREX SIGNAL APP</h5>
                  <br />
                  <TrackVisibility>
                    {({ isVisible }) =>
                    <div className={isVisible ? "animate__animated animate__zoomIn" : ""}>
                    <img src={atp11Img} alt="example Img"/>
                    </div>}
                  </TrackVisibility>
                  <br />
                  <br />

                  <h1>Some Other <span className="chris">Un-publish Apps</span> Created by Our Students Around The Globe</h1><br />

                  <h5>GAME APP</h5>
                  <br />
                  <TrackVisibility>
                    {({ isVisible }) =>
                    <div className={isVisible ? "animate__animated animate__zoomIn" : ""}>
                    <img src={atp12Img} alt="example Img"/>
                    </div>}
                  </TrackVisibility>
                  <br />
                  <br />

                  <h5>LIVE SCORE (FOOTBALL) APP</h5>
                  <br />
                  <TrackVisibility>
                    {({ isVisible }) =>
                    <div className={isVisible ? "animate__animated animate__zoomIn" : ""}>
                    <img src={atp13Img} alt="example Img"/>
                    </div>}
                  </TrackVisibility>
                  <br />
                  <br />

                  <h5>VPN APP</h5>
                  <br />
                  <TrackVisibility>
                    {({ isVisible }) =>
                    <div className={isVisible ? "animate__animated animate__zoomIn" : ""}>
                    <img src={atp14Img} alt="example Img"/>
                    </div>}
                  </TrackVisibility>
                  <br />
                  <br />

                  <Nav.Link href='https://selar.co/ztpm' rel="noreferrer" target='_blank'><h3 className="chris">PAY - REGISTER HERE</h3></Nav.Link><br />

                  <h1>More <span className="chris">Testimonies</span> from Students...</h1><br />

                  <h5>STUDENT CONVERTED THEIR CHURCH WEBSITE TO AN APP</h5>
                  <br />
                  <TrackVisibility>
                    {({ isVisible }) =>
                    <div className={isVisible ? "animate__animated animate__zoomIn" : ""}>
                    <img src={atp18Img} alt="example Img"/>
                    </div>}
                  </TrackVisibility>
                  <br />
                  <br />

                  <h5>STUDENT ATTESTING TO THE GENUINESS/REALITY OF THE COURSE</h5>
                  <br />
                  <TrackVisibility>
                    {({ isVisible }) =>
                    <div className={isVisible ? "animate__animated animate__zoomIn" : ""}>
                    <img src={atp15Img} alt="example Img"/>
                    </div>}
                  </TrackVisibility>
                  <br />
                  <br />

                  <h5>STUDENT ATTESTED THAT THE APP COURSE IS FUN AND INTERESTING</h5>
                  <br />
                  <TrackVisibility>
                    {({ isVisible }) =>
                    <div className={isVisible ? "animate__animated animate__zoomIn" : ""}>
                    <img src={atp20Img} alt="example Img"/>
                    </div>}
                  </TrackVisibility>
                  <br />
                  <br />

                  <h5>STUDENT FROM GHANA LOVE THE APP DEV. SUPPORT GROUP</h5>
                  <br />
                  <TrackVisibility>
                    {({ isVisible }) =>
                    <div className={isVisible ? "animate__animated animate__zoomIn" : ""}>
                    <img src={atp21Img} alt="example Img"/>
                    </div>}
                  </TrackVisibility>
                  <br />
                  <br />

                  <h5>ANOTHER STUDENT ALSO ATTESTING TO THE GENUINESS/REALITY OF THE COURSE</h5>
                  <br />
                  <TrackVisibility>
                    {({ isVisible }) =>
                    <div className={isVisible ? "animate__animated animate__zoomIn" : ""}>
                    <img src={atp22Img} alt="example Img"/>
                    </div>}
                  </TrackVisibility>
                  <br />
                  <br />
                  
                  

                  

                  <Nav.Link href='https://selar.co/ztpm' rel="noreferrer" target='_blank'><h3>PAY - REGISTER HERE</h3></Nav.Link><br />

                  <h5 className="chris">Suported Currencies</h5>
                  <p>NGN, USD, GBP, GHS, KES, ZAR, TZS, UGX, XAF, XOF, RWF</p><br />
                  
                  <h5 className="chris">Payment Options</h5>
                  <p>Bank, Bank Transfer, Visa/Master Card, USSD</p><br />

                  <Nav.Link href='https://selar.co/ztpm' rel="noreferrer" target='_blank'><h3>PAY - REGISTER HERE</h3></Nav.Link><br />

                  <p>If you cannot make payment via the link above you can also reach us on whatsApp for other options.</p>
                  <p className="chris"><a href="https://wa.me/2348163913697">WhatsApp Link</a></p><br />

                  <h5>Act Now!</h5><br />

                  <h3>Note: <span className="chris">Latest Update from Totlesoft Marketing Team:</span></h3>
                  <h5>Please do well to fill in your correct information at the payment page</h5>
                  <p>Name: VERY IMPORTANT</p>
                  <p>Email: VERY IMPORTANT</p>
                  <p>Phone: OPTIONAL</p><br />

                  <h5>Also note that if after payment you were not automatically redirected to course access page, please check your email. A receipt will be sent to your email as shown below:</h5><br />

                  <br />
                  <TrackVisibility>
                    {({ isVisible }) =>
                    <div className={isVisible ? "animate__animated animate__zoomIn" : ""}>
                    <img src={atp23Img} alt="example Img"/>
                    </div>}
                  </TrackVisibility>
                  <br />
                  <br />

                  <h5>If you click on it, it will open a message containing "Go to receipt" and Transaction Details as shown below:</h5><br />
                  <br />
                  <TrackVisibility>
                    {({ isVisible }) =>
                    <div className={isVisible ? "animate__animated animate__zoomIn" : ""}>
                    <img src={atp24Img} alt="example Img"/>
                    </div>}
                  </TrackVisibility>
                  <br />
                  <br />

                  <h5>If you click on the "Go to receipt" button, it will first take you to a page as shown below:</h5><br />
                  <br />
                  <TrackVisibility>
                    {({ isVisible }) =>
                    <div className={isVisible ? "animate__animated animate__zoomIn" : ""}>
                    <img src={atp24bImg} alt="example Img"/>
                    </div>}
                  </TrackVisibility>
                  <br />
                  <br />

                  <h5>And then automatically land you on the COURSE ACCESS PAGE/LINK TO JOIN THE SUPPORT GROUP.</h5><br /><br />
                  

                  <h3>Also, <span className="chris">Please leave a review to help others get this course</span></h3>
                  <h5>in the receipt email, you will find the "Transaction Detail" as show below:</h5>
                  <br />
                  <TrackVisibility>
                    {({ isVisible }) =>
                    <div className={isVisible ? "animate__animated animate__zoomIn" : ""}>
                    <img src={atp25Img} alt="example Img"/>
                    </div>}
                  </TrackVisibility>
                  <br />
                  <br />

                  <h5>If you click on the link under the transaction detail, it will take you to a page as show below:</h5>
                  <br />
                  <TrackVisibility>
                    {({ isVisible }) =>
                    <div className={isVisible ? "animate__animated animate__zoomIn" : ""}>
                    <img src={atp26Img} alt="example Img"/>
                    </div>}
                  </TrackVisibility>
                  <br />
                  <br />

                  <h5>If you click on the "Leave a Review" button, it will take you to a page where you can be able to leave a "A Review" on the course as shown below:</h5>
                  <br />
                  <TrackVisibility>
                    {({ isVisible }) =>
                    <div className={isVisible ? "animate__animated animate__zoomIn" : ""}>
                    <img src={atp27Img} alt="example Img"/>
                    </div>}
                  </TrackVisibility>
                  <br />
                  <br />

                  <h5>Thanks in anticipation for leaving a positive review. God bless you.</h5><br />

                  <Nav.Link href='https://selar.co/ztpm' rel="noreferrer" target='_blank'><h3>PAY - REGISTER HERE</h3></Nav.Link><br />

                  <Nav.Link href='/academy' rel="noreferrer"><h3>Return to Academy Home Page</h3></Nav.Link><br />

                 
                 </div>}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
    </section>
  )
}

